module.exports = __webpack_public_path__ + "img/arrow-left.3bb0025d.svg";